module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0139.jpg?v=55f13a5d";